__turbopack_context__.v({
  "bar-chart": "style-module-scss-module__PxlCxq__bar-chart",
  "bar-fill": "style-module-scss-module__PxlCxq__bar-fill",
  "bar-fill-active": "style-module-scss-module__PxlCxq__bar-fill-active",
  "bar-header": "style-module-scss-module__PxlCxq__bar-header",
  "bar-item": "style-module-scss-module__PxlCxq__bar-item",
  "bar-label": "style-module-scss-module__PxlCxq__bar-label",
  "bar-label-active": "style-module-scss-module__PxlCxq__bar-label-active",
  "bar-percentage": "style-module-scss-module__PxlCxq__bar-percentage",
  "bar-percentage-active": "style-module-scss-module__PxlCxq__bar-percentage-active",
  "bar-track": "style-module-scss-module__PxlCxq__bar-track",
  "card": "style-module-scss-module__PxlCxq__card",
  "card-label": "style-module-scss-module__PxlCxq__card-label",
  "cards-row": "style-module-scss-module__PxlCxq__cards-row",
  "change-down": "style-module-scss-module__PxlCxq__change-down",
  "change-up": "style-module-scss-module__PxlCxq__change-up",
  "distribution-card": "style-module-scss-module__PxlCxq__distribution-card",
  "heading-dropdown-layer": "style-module-scss-module__PxlCxq__heading-dropdown-layer",
  "health-card": "style-module-scss-module__PxlCxq__health-card",
  "health-content": "style-module-scss-module__PxlCxq__health-content",
  "health-metric": "style-module-scss-module__PxlCxq__health-metric",
  "health-metric-label": "style-module-scss-module__PxlCxq__health-metric-label",
  "health-metric-unit": "style-module-scss-module__PxlCxq__health-metric-unit",
  "health-metric-value": "style-module-scss-module__PxlCxq__health-metric-value",
  "highlight-badge": "style-module-scss-module__PxlCxq__highlight-badge",
  "highlight-label": "style-module-scss-module__PxlCxq__highlight-label",
  "legend": "style-module-scss-module__PxlCxq__legend",
  "legend-item": "style-module-scss-module__PxlCxq__legend-item",
  "legend-label": "style-module-scss-module__PxlCxq__legend-label",
  "legend-swatch": "style-module-scss-module__PxlCxq__legend-swatch",
  "market-dynamics": "style-module-scss-module__PxlCxq__market-dynamics",
  "pie-center-bg": "style-module-scss-module__PxlCxq__pie-center-bg",
  "pie-center-label": "style-module-scss-module__PxlCxq__pie-center-label",
  "pie-center-pct": "style-module-scss-module__PxlCxq__pie-center-pct",
  "pie-section": "style-module-scss-module__PxlCxq__pie-section",
  "pie-slice": "style-module-scss-module__PxlCxq__pie-slice",
  "pie-svg": "style-module-scss-module__PxlCxq__pie-svg",
  "section-description": "style-module-scss-module__PxlCxq__section-description",
  "trend-card": "style-module-scss-module__PxlCxq__trend-card",
  "trend-change": "style-module-scss-module__PxlCxq__trend-change",
  "trend-content": "style-module-scss-module__PxlCxq__trend-content",
  "trend-dates": "style-module-scss-module__PxlCxq__trend-dates",
  "trend-header": "style-module-scss-module__PxlCxq__trend-header",
  "trend-svg": "style-module-scss-module__PxlCxq__trend-svg",
  "trend-value": "style-module-scss-module__PxlCxq__trend-value",
  "volume-card": "style-module-scss-module__PxlCxq__volume-card",
  "volume-disclaimer": "style-module-scss-module__PxlCxq__volume-disclaimer",
  "volume-header": "style-module-scss-module__PxlCxq__volume-header",
  "volume-highlight": "style-module-scss-module__PxlCxq__volume-highlight",
  "volume-info": "style-module-scss-module__PxlCxq__volume-info",
  "volume-suffix": "style-module-scss-module__PxlCxq__volume-suffix",
  "volume-value": "style-module-scss-module__PxlCxq__volume-value",
  "volume-value-row": "style-module-scss-module__PxlCxq__volume-value-row",
});
